import * as yup from 'yup';

import { parseDate } from '../../dates/parseDate';
import { dateFormatter } from '../../formatters/dateFormatter';
import { DateTypeBase } from '../../baseTypes/DateTypeBase';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_TIME } from '../constants';

export class DateType extends DateTypeBase {
  group = TYPE_GROUP_TIME;

  name = 'Date';

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Data,
    TypeContextEnum.Properties,
  ];

  friendlyName = 'Date';

  get example() {
    return new Date();
  }

  get default(): any {
    return new Date();
  }

  formatter = (date: any, opts: any) =>
    dateFormatter(date, 'yyyy-MM-dd', opts?.timeZone);

  buildSchema() {
    return yup.date().nullable();
  }

  parseValue = (value: any) => parseDate(value);
}

const definition = new DateType();

Types.addBaseType(definition);
export { definition as DateDefinition };
